import {
  createContext,
  useState,
  useMemo,
  useEffect,
} from 'react';

export const I18nContext = createContext({
  locale: 'en',
  setLocale: (_locale: string) => {},
  localeData: null,
});

type Props = {
  initialLocale: string;
  children: React.ReactNode;
};

export default function I18nProvider({ children, initialLocale }: Props) {
  const [locale, setLocale] = useState(initialLocale);
  const [localeData, setLocaleData] = useState<any>(null);

  useEffect(() => {
    const loadLocaleData = async () => {
      const loadedLocaleData = await import(`../locales/${locale}.ts`);

      setLocaleData(loadedLocaleData.default);
    };

    loadLocaleData();
  }, [locale]);

  const value = useMemo(() => {
    return {
      locale,
      setLocale,
      localeData,
    };
  }, [locale, localeData]);

  return (
    <I18nContext.Provider value={value}>
      {localeData && (
        children
      )}
    </I18nContext.Provider>
  );
}
